<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-aside :width="width"
                      style="padding:5px 0 0 10px;">
                <workerTree :width="width" ref="menuTree" @selTree="selTree"></workerTree>
            </el-aside>
            <div class="Ydriver"></div>
            <el-main>
                <toolBar :loading.sync="mainLoading"
                         :menuId="menu_id"
                         :searchData="searchData"
                         @search="search"
                         @doBtn="doBtn">
                </toolBar>
                <tableGrid ref="tableGrid"
                           adaptiveHeight="110"
                           :headList="headList"
                           :dataList="dataList"
                           :pageInfo="pageInfo"
                           @tableOpt="tableOpt"
                           @toPage="toPage"
                           :loading="loading">
                </tableGrid>
            </el-main>
        </el-container>

        <editDialog v-if="showEditDialog"
                    :formData="formData"
                    :loading="dialogLoading"
                    @closeDialog="closeDialog"
                    @submitForm="submitForm">
        </editDialog>

        <importExcel v-if="showImportDialog"
                     :importUrl="importUrl"
                     :mouduleUrl="mouduleUrl"
                     @refresh="getListData"
                     @closeDialog="closeDialog">
        </importExcel>

        <createUser v-if="showCreateUser"
                    @doCreate="doCreate"
                    @closeDialog="closeDialog">
        </createUser>
        <userInfo v-if="showUserInfo"
                  :formData="formData"
                  @closeDialog="closeDialog">
        </userInfo>
    </div>
</template>

<script>
    import toolBar from '@/components/tools/toolBar'
    import tableGrid from '@/components/tools/table'
    import importExcel from "@/components/tools/excel/import";
    import workerTree from "@/components/rszy/staff/workerTree";
    import editDialog from "@/components/rszy/staff/editDialog";
    import userInfo from "@/components/rszy/staff/userInfo";
    import createUser from '@/components/rszy/staff/createUser'

    export default {
        name: "workerManage",
        props: ['menuData'],
        components: {workerTree, tableGrid, editDialog, createUser, userInfo, importExcel,toolBar},
        data() {
            return {
                mainLoading: false,
                menu_id: this.menuData.menuId,
                searchData: {
                    fields: [{
                        tag: "el-input",
                        label: "姓名",
                        vModel: "keywords",
                    }],
                    formData: {
                        keywords: ""
                    },
                },

                width: "280px",

                showEditDialog: false,
                dialogLoading: false,
                showCreateUser: false,
                showUserInfo: false,

                treeData: {
                    id: "0",
                    name: ""
                },
                formData: {},
                dataList: [],
                loading: false,
                headList: [
                    {
                        column_name: "_px", column_comment: "序号", column_width: "70"
                    },
                    {
                        column_name: "staffNo", column_comment: "工号", column_width: "100"
                    },
                    {
                        column_name: "staffName", column_comment: "姓名", column_width: "200"
                    },
                    {
                        column_name: "loginName", column_comment: "授权登录用户", column_width: "200"
                    },
                    {
                        column_name: "departmentName", column_comment: "部门", column_width: "250"
                    },
                    {
                        column_name: "functions", column_comment: "职责", column_width: "100"
                    },
                    {
                        column_name: "tel", column_comment: "电话", column_width: "150"
                    },
                    {
                        column_name: "remark", column_comment: "备注"
                    }
                ],
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },

                showImportDialog: false,
                importUrl: "/staff/importInfo",
                mouduleUrl: "/staff/standardExcel",
                outportUrl: "/staff/excel",
            }
        },
        mounted() {
            this.getListData();
        },
        methods: {
            async getListData() {
                this.loading = true;
                let param = {
                    url: "/staff/list",
                    param: {
                        departmentId: this.treeData.id,
                        ...this.searchData.formData,
                        pageSize: this.pageInfo.pagesize,
                        currentPage: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == '0') {
                    this.dataList = data.data.varList;
                    this.pageInfo.total = data.data.page.totalResult;
                }
                this.loading = false;
                this.$refs.tableGrid.clearSelList();
            },

            closeDialog() {
                this.showImportDialog = false;
                // this.showOutportDialog = false;
                this.showEditDialog = false;
                this.showCreateUser = false;
                this.showUserInfo = false;
            },

            async submitForm(form) {
                this.formData = form;
                this.dialogLoading = true;

                let param = {
                    ...this.formData,
                }
                const data = await this.$sqlOpt.save.save(param, "/staff/save");
                this.dialogLoading = false;
                console.info(data.infoCode)

                if (data.infoCode === '0') {
                    this.$refs.tableGrid.clearSelList();
                    this.$message.success("保存成功");
                    this.closeDialog();
                    await this.getListData();
                }

            },
            toPage() {
                this.getListData();
            },
            search() {
                this.pageInfo.page = 1;
                this.getListData();
            },
            async doBtn(type) {
                let selList = this.$refs.tableGrid.getSelList();
                if (type === "add") {

                    this.formData = {};
                    let param = {
                        url: "/staff/goAdd",
                        param: {}
                    }
                    const data = await this.$store.dispatch('pubMethod', param);
                    if (data.infoCode == "0") {
                        this.formData = data.data.staff;
                        this.formData.departmentId = this.treeData.id;
                        this.formData.departmentName = this.treeData.name;
                    }
                    this.showEditDialog = true;
                }
                if (type === "edit" || type === "delete" || type === "cancel") {
                    this.formData = selList;
                    if (this.$pub.isEmptyObjct(selList)) {
                        this.$message({message: '请先选择一条记录', type: 'error'});
                        return;
                    }

                    if (type === "edit") {
                        this.showEditDialog = true;
                    }

                    if (type === "delete" || type === "cancel") {
                        let param = {
                            url: "/staff/delete",
                            param: {
                                staffId: this.formData.staffId,
                            }
                        }
                        this.$sqlOpt.del.del(param, this, this.getListData);
                    }
                }
                if (type === "outport") {
                    window.open(window.host.ProjectUrl + this.outportUrl)
                    // await this.exportToExcel();
                    // this.showOutportDialog = true;
                }
                if (type === "import") {
                    this.showImportDialog = true;
                }
                if (type === "createUser") {
                    let selection = this.$refs.tableGrid.getList();
                    if (selection && selection.length < 1) {
                        this.$message({
                            message: '请先选择一条记录',
                            type: 'error'
                        })
                    } else {
                        let index = selection.findIndex(item => {
                            return item.role_name !== "" && item.role_name !== null
                        });
                        if (index > -1) {
                            this.$confirm('选中用户已分配过账户,是否继续?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(async () => {
                                this.showCreateUser = true;
                            }).catch(() => {

                            });
                        } else {
                            this.showCreateUser = true;
                        }
                    }
                }
            },
            async doCreate(data) {
                this.showCreateUser = false;
                this.$loading();
                let selList = this.$refs.tableGrid.getList();
                //已分配过的用户
                let AUserList = [];
                //未分配过的用户
                let BUserList = [];
                selList.map(item => {
                    if (item.role_name !== "" && item.role_name !== null)
                        AUserList.push(item);
                    else
                        BUserList.push(item);
                });
                let param = {
                    roleData: data,
                    AUserList: AUserList,
                    BUserList: BUserList,
                }
                const ret = await this.$sqlOpt.rszy.createUser(param);
                if (ret.code === '1') {
                    this.$message({message: '创建或更新用户成功', type: 'success'});
                    this.getListData();
                }
                this.$loading().close();
            },
            // ----------以下为导出Excel数据功能--------------
            async exportToExcel() {
                this.$loading();
                let param = {
                    id: this.treeData.id,
                    ...this.searchData,
                    pagesize: 9999,
                    page: 1
                }
                const data = await this.$sqlOpt.rszy.getWorkerList(param)
                if (data.code === '1') {
                    this.outportData = data.data.list;
                }
                this.$loading().close();
            },
            async tableOpt(type, data) {
                if (type === "setUserInfo") {
                    this.formData = data;
                    this.showUserInfo = true;
                }
            },
            //点击左边表格
            selTree(data) {
                this.treeData = data;
                this.search();
            },
        }
    }
</script>

<style scoped lang="scss">
    .mainInfo {
        .el-header {
            padding: 0px;
        }

        .el-main {
            padding: 0px;
        }

        .Xdriver {
            position: relative;
            margin: 0 0;
            height: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }

        .Ydriver {
            position: relative;
            margin: 0 10px;
            width: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }
    }
</style>
